import React from 'react'
import PropTypes from 'prop-types'
import { Divider } from 'antd'

import 'styles/AntOverrides.css'
import 'styles/ChecComponents.css'

const ComponentDivider = ({ type, dashed, className, orientation, style }) => (
  <Divider
    type={type}
    dashed={dashed}
    className={
      typeof className === 'string'
        ? `chec-table-row ${className}`
        : (record, index) => `chec-table-row ${className(record, index)}`
    }
    orientation={orientation}
    style={style}
  />
)

ComponentDivider.defaultProps = {
  type: 'horizontal',
  dashed: false,
  className: PropTypes.string,
  orientation: 'center',
}

ComponentDivider.propTypes = {
  type: PropTypes.oneOf(['horizontal', 'vertical']),
  dashed: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  orientation: PropTypes.oneOf(['left', 'right', 'center']),
  style: PropTypes.object,
}

export default ComponentDivider
